export default __webpack_public_path__ + "static/media/out-from-canada.b7bbbdcd.jpg";